import { ResponseFetchStudyList } from '@vindr/services/apis/study.api';
import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
import { Button, Typography } from 'antd';
import { isEqual } from 'lodash';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useImmer } from 'use-immer';
import ColumnTemplate from '../../Templates/columns/columnRenderTemplates';
import Table from '../../ui/Table';
import { ReportFormStates } from './ReportForm';

const { Title } = Typography;

interface SelectReportProps {
  shouldNotMatchOrCreateOrder: boolean; // using for the case open report from assign page, we should not match or create order here
  orders: ReportFormStates['matchedOrders'];
  // userInfo: typeof keycloak.userInfo;
  selectedOrder: ReportFormStates['SelectedOrderType'];
  // selectedReport: Awaited<ReturnType<typeof getReports>>['data'][number];
  onChangeOrder: (order: any) => void;
  // onCreate: () => void;
  // onEdit: () => void;
  // onCancel: () => void;

  onMatchOrder: () => void;
  onCreateOrder: () => void;
  study: ResponseFetchStudyList['data'][number];
  loading: boolean;
}

const SelectReport = ({
  shouldNotMatchOrCreateOrder = false,
  orders,
  // userInfo,
  selectedOrder,
  // selectedReport,
  onChangeOrder,
  // onCreate,
  // onEdit,
  // onCancel,
  onMatchOrder,
  onCreateOrder,
  loading,
  study,
}: SelectReportProps) => {
  const { t } = useTranslation('Vindoc');
  const [selectedRowKeys, setSelectedRowKeys] = useImmer([]);

  return (
    <div className="select-report">
      <div className="flex flex-wrap items-baseline justify-between pb-3 pt-0">
        <Title level={4} className="mb-0 pt-0">
          {t('Order List')}
        </Title>
        <div className="flex flex-wrap items-baseline space-y-2">
          {!shouldNotMatchOrCreateOrder && (
            <>
              <Button
                onClick={onMatchOrder}
                size="small"
                className="mr-2"
                disabled={!keycloak.hasOneOfPerm([PERMISSIONS.studylist.match])}
              >
                {t('Match Order')}
              </Button>
              {/* {study?.match_status !== MATCH_STATUS.MATCH && (
              )} */}
              <Button
                onClick={onCreateOrder}
                size="small"
                disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.create])}
              >
                {t('Create Order')}
              </Button>
            </>
          )}
        </div>
      </div>
      <Table
        columns={[
          ColumnTemplate.Date({
            title: t('Scheduled Date'),
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            sorter: false,
            width: 90,
          }),
          {
            title: t('Procedure Name'),
            dataIndex: 'procedure',
            key: 'procedure',
            width: 170,
            ellipsis: true,
            render: (text, record) => text?.compact_name || text?.name,
          },
          {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (value) => t(ORDER_STATUS[value]),
          },
        ]}
        dataSource={orders as any}
        rowKey="id"
        loading={loading}
        wrapperClassName="h-auto w-full overflow-auto cursor-pointer"
        className="w-full"
        scroll={{ y: 180 }}
        pagination={false}
        rowSelection={{
          type: 'radio',
          selectedRowKeys: selectedRowKeys.length ? selectedRowKeys : [selectedOrder?.id],
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(() => selectedRows[0]);
            onChangeOrder(selectedRows[0]);
          },
          columnWidth: 0,
          renderCell: () => null,
        }}
        onRow={(record: typeof orders[number]) => {
          return {
            onClick: (event) => {
              event.stopPropagation();
              event.preventDefault();
              const order = orders.find((it) => it.id == record.id);

              onChangeOrder(order);
              setSelectedRowKeys(() => order);
            },
          };
        }}
      />
    </div>
  );
};

export default memo(
  SelectReport,
  (prev, next) =>
    isEqual(prev.shouldNotMatchOrCreateOrder, next.shouldNotMatchOrCreateOrder) &&
    isEqual(prev.orders, next.orders) &&
    isEqual(prev.selectedOrder, next.selectedOrder) &&
    isEqual(prev.study, next.study) &&
    isEqual(prev.loading, next.loading)
);
